.list-item-selection {
    width: 100%;
    height: 100%;
    padding: 16px;
    box-sizing: border-box;
    background-color: var(--off-white);
    border: 1px solid var(--off-white-dk);
    border-radius: 3px;
    overflow-y: auto;
}
